import { useState, useEffect } from 'react';
import { FetchEventData } from '../Utils/FetchImageEventData';

export const useCurrentMonthEvents = () => {
  const [eventsData, setEventsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadEvents = async () => {
      try {
        setLoading(true);
        const data = await FetchEventData("September");
        setEventsData(data);
        setError(null);
      } catch (err) {
        console.error("Error loading current month events:", err);
        setError(err);
        setEventsData(null);
      } finally {
        setLoading(false);
      }
    };
    loadEvents();
  }, []);

  return { 
    eventsData, 
    loading, 
    error,
    events: eventsData?.events || [],
    highlightEvent: eventsData?.events?.[0] || null,
    monthlyEvents: eventsData?.events?.slice(1) || []
  };
};
